import { escapeRegExp, filter, sortBy } from 'lodash'
import ReactCountryFlag from 'react-country-flag'

import allCountries from 'utils/allCountries'
import { translate } from 'utils/translation'

import { FLAG_STYLES, FIELD_NAMES, ERROR_MESSAGES, FieldNames } from '../consts'
import { RecurlyErrorDetail } from '../index'
import { RecurlyErrors } from '../../../providers'

export interface CountryOption {
  id: number
  label: string
  value: string
  icon: JSX.Element
}

export const getRecurlyErrors = (
  details: RecurlyErrorDetail[],
): RecurlyErrors => {
  return details.reduce<RecurlyErrors>((acc, { field }) => {
    const fieldName = FIELD_NAMES[field as keyof FieldNames]
    if (fieldName) {
      acc[fieldName] = {
        message: translate(ERROR_MESSAGES[fieldName] || 'alert_required'),
        type: 'manual',
      }
    }
    return acc
  }, {})
}

export const filterCountries = (search: string): CountryOption[] => {
  const regExps = (search || '')
    .split(' ')
    .filter((searchWord) => searchWord.trim().length)
    .map((searchWord) => new RegExp(escapeRegExp(searchWord) || '.*.', 'i'))
  const filteredOptions = filter(allCountries, (c) => {
    return regExps.every((reg) => reg.test(c.countryIsoCode))
  })
  const items = filteredOptions.map((country) => ({
    ...country,
    id: Number(country.id),
    label: translate(country.name),
    value: country.countryIsoCode,
    icon: (
      <div className="tw-w-5 tw-h-5">
        <ReactCountryFlag
          countryCode={country.countryIsoCode.substring(0, 2)}
          svg
          style={FLAG_STYLES}
        />
      </div>
    ),
  }))
  return sortBy(items, ['name'])
}

export const getRecurlyInputStyles = ({ content }: { content: string }) => ({
  fontSize: '15px',
  fontFamily: 'Roboto, sans-serif',
  fontWeight: 400,
  padding: '0.5rem',
  placeholder: {
    content,
    color: '#A1A1AA',
  },
})
